import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { wagmiConfig } from './config/wagmi'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Root element #root not found')

createRoot(container).render(
  <StrictMode>
    {/* reconnectOnMount is OFF on purpose. wagmi's automatic reconnect asks each
        connector `isAuthorized()`, and a TARGETED injected connector answers yes
        from `eth_accounts` alone — which would silently connect any visitor whose
        MetaMask has ever authorised this domain, even if they never pressed
        Connect here, or disconnected. `useWallet` performs the reconnect itself,
        gated on the app's own record of a deliberate connection. See
        src/lib/connection.ts. */}
    <WagmiProvider config={wagmiConfig} reconnectOnMount={false}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </WagmiProvider>
  </StrictMode>,
)
